import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useStyles = makeStyles((theme) => ({
  termsSection: {
    '& hr': {
      margin: '32px 0px',
      backgroundColor: colorSet.gray200
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 8,
      '& hr': {
        marginBottom: 24
      }
    }
  },
  checkBoxLabel: {
    '& .MuiTypography-root': {
      width: '100%'
    },
    '& .MuiTypography-body2': {
      lineHeight: '36px',
      '& b': {
        fontWeight: 400,
        color: colorSet.primary500,
        '&.agreeAll': {
          fontWeight: 700
        }
      }
    },
    '& button': {
      '& span': {
        color: colorSet.gray600,
        padding: '9px'
      }
    }
  },
  checkBox: {
    '& svg': {
      width: 20,
      height: 20
    },
    '&.MuiCheckbox-colorSecondary.Mui-checked': {
      color: colorSet.primary500
    }
  }
}));
